import { render, staticRenderFns } from "./header.vue?vue&type=template&id=b4479528&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./header.vue?vue&type=style&index=1&id=b4479528&scoped=true&lang=scss&"
import style2 from "./header.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4479528",
  null
  
)

export default component.exports